import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/static/icons/white_plus.svg'


const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "product-decorator__title" }
const _hoisted_3 = ["open"]
const _hoisted_4 = {
  key: 0,
  class: "product-decorator__default-content"
}
const _hoisted_5 = { class: "product-decorator__default-title" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "product-decorator__out-of-stock-info"
}
const _hoisted_8 = { class: "product-decorator__config-decoration" }

import { ref, computed, inject, onMounted } from 'vue';

import { configuratorStateKey } from '../ProductConfiguratorKeys';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import ConfiguratorChevron from '../ConfiguratorChevron.vue';
import DecorationPlacement from './DecorationPlacement.vue';
import DecorationTechnique from './DecorationTechnique.vue';
import DecorationBottomMenu from './DecorationBottomMenu.vue';
import DecorationUpload from './DecorationUpload.vue';
import DecorationSummary from './DecorationSummary.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfiguratorProductDecorator',
  props: {
  variants: {
    type: Array,
    required: true,
  },
  decorations: {
    type: Array,
    required: true,
  },
  outOfStock: {
    type: Boolean,
    default: false,
  },
},
  emits: ['started', 'techniqueVariantSelected'],
  setup(__props, { emit: __emit }) {

const { websiteText } = useWebsiteTexts();
const {
  configuratorState,
  updateSelection,
  updateDecorationSteps,
  removeDecoration,
  removeUpload
} = inject(configuratorStateKey);

const emit = __emit;
const decorator = ref(null);
const toggleState = ref(true);
const decorationSteps = computed(() => configuratorState.value.decorationSteps);
const selections = computed(() => configuratorState.value.selections);

if (typeof window !== 'undefined') {
  toggleState.value = JSON.parse(localStorage.getItem("configurator:decoration-accordion-open-state") || 'true');
}

const props = __props;

const availableTechniques = computed(() => {
  const selected = configuratorState.value.selections.selectedPlacement;
  if (!selected) return [];
  return props.decorations.find(d => d.systemId === selected)?.techniques || [];
});

function goToStep(step: string) {
  Object.keys(configuratorState.value.decorationSteps).forEach((k) => {
    updateDecorationSteps(k, k === step);
  });
}

function beginDecorating() {
  emit('started');
  goToStep('placeDecoration');
}

function placementSelected(id: string) {
  updateSelection('selectedPlacement', id);
  goToStep('pickTechnique');
}

function placementValueSelected(value: string) {
  updateSelection('selectedPlacementName', value);
}

function techniqueSelected(id: string) {
  updateSelection('selectedTechnique', id);
  updateSelection('desiredWidth', 0);
  updateSelection('desiredHeight', 0);
}

function techniqueVariantSelected(variant) {
  updateSelection('selectedTechniqueVariant', variant.id);
  updateSelection('selectedTechniqueVariantPrices', variant.brackets);
  updateSelection('selectedTechniqueVariantAddons', variant.addons);

  if (variant.colors) {
    updateSelection('selectedTechniqueVariantInputColors', variant.colors);
  }

  emit('techniqueVariantSelected', variant);
}

function desiredWidthUpdated(value: number) {
  updateSelection('desiredWidth', value);
}

function desiredHeightUpdated(value: number) {
  updateSelection('desiredHeight', value);
}

function fileUploaded(file) {
  if (!file) return;
  updateSelection('fileUpload', file);
  goToStep('confirmDecoration');
}

function fileRemoved() {
  removeUpload();
  updateSelection('fileUpload', null);
  goToStep('uploadDecoration');
}

function accordianToggle() {
  toggleState.value = !toggleState.value;
  localStorage.setItem("configurator:decoration-accordion-open-state", JSON.stringify(toggleState.value));
}

function saveDecoration() {
  goToStep('decorationSummary');
}

function removeDecorationData() {
  removeUpload();
  removeDecoration();
  goToStep('initialState');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    disabled: __props.outOfStock,
    ref_key: "decorator",
    ref: decorator,
    class: "product-decorator",
    id: "decoration-anchor"
  }, [
    _createElementVNode("div", {
      tabindex: "0",
      class: "product-decorator__title-and-toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (accordianToggle())),
      onKeypress: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (accordianToggle()), ["prevent"]), ["space"]))
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(websiteText)('decoration__decorate_product').value), 1),
      _createVNode(ConfiguratorChevron, { open: toggleState.value }, null, 8, ["open"])
    ], 32),
    _createElementVNode("div", {
      open: toggleState.value,
      class: "product-decorator__content"
    }, [
      (decorationSteps.value.initialState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(websiteText)('decoration__add_decoration').value), 1),
            _createElementVNode("div", {
              class: "product-decorator__default-cta",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (beginDecorating())),
              disabled: __props.outOfStock
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]), 8, _hoisted_6),
            (__props.outOfStock)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(websiteText)('decoration__out_of_stock').value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (decorationSteps.value.placeDecoration
             || decorationSteps.value.pickTechnique)
          ? (_openBlock(), _createBlock(DecorationPlacement, {
              key: 0,
              placements: __props.decorations,
              selected: selections.value.selectedPlacement,
              onSelected: placementSelected,
              onSelectedValue: placementValueSelected
            }, null, 8, ["placements", "selected"]))
          : _createCommentVNode("", true),
        (decorationSteps.value.pickTechnique)
          ? (_openBlock(), _createBlock(DecorationTechnique, {
              key: 1,
              variants: props.variants,
              techniques: availableTechniques.value,
              selected: selections.value.selectedTechnique,
              selectedVariant: selections.value.selectedTechniqueVariant,
              selectedColors: selections.value.selectedTechniqueVariantInputColors,
              "selected-width": selections.value.desiredWidth,
              "selected-height": selections.value.desiredHeight,
              onSelected: techniqueSelected,
              onSelectedVariant: techniqueVariantSelected,
              onDesiredWidthUpdated: desiredWidthUpdated,
              onDesiredHeightUpdated: desiredHeightUpdated
            }, null, 8, ["variants", "techniques", "selected", "selectedVariant", "selectedColors", "selected-width", "selected-height"]))
          : _createCommentVNode("", true),
        (decorationSteps.value.uploadDecoration
          || decorationSteps.value.confirmDecoration)
          ? (_openBlock(), _createBlock(DecorationUpload, {
              key: 2,
              upload: selections.value.fileUpload,
              onUpload: fileUploaded,
              onRemove: fileRemoved
            }, null, 8, ["upload"]))
          : _createCommentVNode("", true),
        (decorationSteps.value.decorationSummary)
          ? (_openBlock(), _createBlock(DecorationSummary, {
              key: 3,
              placements: __props.decorations,
              onEdit: goToStep
            }, null, 8, ["placements"]))
          : _createCommentVNode("", true),
        _createVNode(DecorationBottomMenu, {
          onGoToStep: goToStep,
          onSave: saveDecoration,
          onRemove: removeDecorationData
        })
      ])
    ], 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})